import { Box, Divider, Skeleton, Stack, Typography as T } from "@mui/material";
import useDataset from "datasets/hooks/useDataset";
import useStatistics from "datasets/hooks/useStatistics";
import { format } from "date-fns";
import prettyBytes from "pretty-bytes";
import { AwsIcon } from "~/assets/icons";
import FlatCard from "~/components/FlatCard";

const formatDate = (timestamp: string) => {
  const date = new Date(timestamp);
  return format(date, "MMM dd, yyyy");
};

const OverviewStats = () => {
  const { data: dataset, isLoading: loadingDataset } = useDataset();
  const { data: stats, isLoading: loadingStats } = useStatistics(dataset?.id);

  return (
    <FlatCard
      sx={{
        border: "1px solid #dadada",
        borderRadius: 1.25,
        px: 1,
        py: 1.5,
        width: "100%",
      }}
    >
      <Box display="flex" flex={1} lineHeight="22px">
        <Box display="flex" flex={1} alignItems="center" justifyContent="center">
          {loadingDataset ? (
            <Skeleton variant="rounded" height={27} width={60} />
          ) : (
            dataset?.cloud_providers[0].includes("aws") && <AwsIcon width={36} />
          )}
        </Box>
        <Divider sx={{ my: "unset" }} orientation="vertical" variant="middle" flexItem />
        <Box display="flex" flex={1} justifyContent="center" p={1.5}>
          {loadingDataset || loadingStats ? (
            <Skeleton variant="text" height={27} width={100} />
          ) : (
            <T color="inherit" fontSize={18} fontWeight={600}>
              {stats?.table_total_bytes !== undefined
                ? prettyBytes(stats?.table_total_bytes)
                : "? bytes"}
            </T>
          )}
        </Box>
        <Divider sx={{ my: "unset" }} orientation="vertical" variant="middle" flexItem />
        <Stack justifyContent="center" alignItems="center" textAlign="center" flex={1}>
          {loadingDataset ? (
            <Skeleton variant="text" height={22} width={90} />
          ) : (
            dataset?.updated_at && (
              <>
                <T color="inherit" fontSize={12} lineHeight={1.25}>
                  Updated
                </T>
                <T color="inherit" fontSize={18} fontWeight={600} lineHeight={1.25}>
                  {formatDate(dataset.updated_at)}
                </T>
              </>
            )
          )}
        </Stack>
      </Box>
    </FlatCard>
  );
};

export default OverviewStats;
